import { render, staticRenderFns } from "./entity-document-thumbnail.vue?vue&type=template&id=acefb982&scoped=true"
import script from "./entity-document-thumbnail.vue?vue&type=script&lang=js"
export * from "./entity-document-thumbnail.vue?vue&type=script&lang=js"
import style0 from "./entity-document-thumbnail.vue?vue&type=style&index=0&id=acefb982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acefb982",
  null
  
)

export default component.exports